import { IssueCaseDoc } from '@gooduncles/gu-app-schema';
import { Button, Popconfirm, message, notification } from 'antd';
import { FC } from 'react';
import { useAuth } from 'src/stores/auth-context';

import { deleteIssueCase } from 'src/utils/firebase/firebase-short-cut';
import { isIssueCaseEditable } from 'src/utils/issue/issue-util';

interface IssueCaseHeaderButtonsProps {
  issueCaseDoc: IssueCaseDoc;
  hasIssueTasks: boolean;
}

const IssueCaseHeaderButtons: FC<IssueCaseHeaderButtonsProps> = ({ issueCaseDoc, hasIssueTasks }) => {
  const { user } = useAuth();
  const deletable = isIssueCaseEditable(issueCaseDoc);

  const onDeleteIssueCase = async (issueCaseId: string) => {
    if (!user) {
      message.error('사용자 정보가 없습니다. 다시 로그인 해주세요.');
      return;
    }
    try {
      await deleteIssueCase(issueCaseId);
      message.success('이슈 케이스가 삭제되었습니다.');
    } catch (error) {
      console.error(error);
      notification.error({ message: '이슈 케이스 삭제에 실패했습니다. 다시 시도해주세요.' });
    }
  };

  return (
    <Popconfirm
      title='삭제하시겠습니까?'
      onConfirm={() => onDeleteIssueCase(issueCaseDoc._id)}
      okText='삭제'
      okButtonProps={{ danger: true, disabled: hasIssueTasks || !deletable }}
      cancelText='취소'>
      <Button type='default' size='small' danger disabled={hasIssueTasks || !deletable}>
        삭제
      </Button>
    </Popconfirm>
  );
};

export default IssueCaseHeaderButtons;
